<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Camiones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">Administración</li>
                  <li class="breadcrumb-item active">Flota</li>
                  <li class="breadcrumb-item active">Camiones</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-car me-2 text-primary"></i>
                          Gestión de Camiones
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra la información de camiones y sus documentos
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-info"
                          @click="pivotTable()"
                          v-if="
                            $store.getters.can('argentina.camiones.pivotTable')
                          "
                          data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica"
                        >
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal_form_vehiculo_export"
                          v-if="$store.getters.can('argentina.camiones.export')"
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="$store.getters.can('argentina.camiones.create')"
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nuevo camión"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nuevo Camión
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="getIndex()"
                          data-bs-toggle="tooltip"
                          title="Actualizar datos"
                        >
                          <i class="fas fa-sync-alt me-1"></i>
                          Actualizar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro Placa -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.placa"
                          @keyup="getIndex()"
                          placeholder="Buscar placa..."
                        />
                      </div>

                      <!-- Filtro Modelo -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.modelo"
                          @change="getIndex()"
                          placeholder="Buscar modelo..."
                        />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Empresa -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.selct_empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="empresas"
                          :filterable="false"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Filtro Satelital -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-satellite-dish me-1"></i>
                          Satelital
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.tiene_satelital"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option value="1">Sí tiene</option>
                          <option value="0">No tiene</option>
                        </select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-12 col-lg-2 d-flex align-items-end">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Camiones
                  </h6>
                  <span class="badge bg-primary">
                    {{ vehiculos.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      :class="[
                        'text-center bg-dark text-white text-nowrap',
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light',
                      ]"
                    >
                      <tr>
                        <th class="text-center" style="width: 80px">
                          <i class="fas fa-image"></i>
                        </th>
                        <th>
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                        </th>
                        <th>
                          <i class="fas fa-tachometer-alt me-1"></i>
                          Odómetro
                        </th>
                        <th>
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </th>
                        <th>
                          <i class="fas fa-tag me-1"></i>
                          Marca
                        </th>
                        <th>
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                        </th>
                        <th>
                          <i class="fas fa-gas-pump me-1"></i>
                          Combustible
                        </th>
                        <th>
                          <i class="fas fa-car me-1"></i>
                          Tipo
                        </th>
                        <th>
                          <i class="fas fa-satellite-dish me-1"></i>
                          Último GPS
                        </th>
                        <th>
                          <i class="fas fa-file-alt me-1"></i>
                          Documentos
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th class="text-center" style="width: 120px">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="vehiculo in vehiculos.data" :key="vehiculo.id">
                        <td class="text-center">
                          <a
                            v-if="vehiculo.link_fotografia"
                            :href="uri_docs + vehiculo.link_fotografia"
                            target="_blank"
                            class="d-inline-block"
                          >
                            <img
                              :src="uri_docs + vehiculo.link_fotografia"
                              alt="Vehículo"
                              class="rounded shadow-sm"
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                            />
                          </a>
                          <div
                            v-else
                            class="d-flex align-items-center justify-content-center rounded"
                            :class="
                              $store.getters.getDarkMode
                                ? 'bg-secondary'
                                : 'bg-light'
                            "
                            style="width: 50px; height: 50px; margin: 0 auto"
                          >
                            <i class="fas fa-car text-muted"></i>
                          </div>
                        </td>
                        <td>
                          <span
                            class="fw-bold"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.placa }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.odometro }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              vehiculo.empresa != null
                                ? vehiculo.empresa.razon_social
                                : "No encontrada"
                            }}
                          </span>
                        </td>
                        <td>
                          <span class="badge bg-info">{{
                            vehiculo.nMarca
                          }}</span>
                        </td>
                        <td>
                          <span class="badge bg-secondary">{{
                            vehiculo.modelo
                          }}</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.nCombustible }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              vehiculo.tipo_vehiculo_id
                                ? vehiculo.tipo_vehiculo.nombre
                                : ""
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            v-if="vehiculo.fecha_ultimo_gps"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                            :title="
                              formatearFechaHora(vehiculo.fecha_ultimo_gps)
                            "
                          >
                            {{ formatearFechaHora(vehiculo.fecha_ultimo_gps) }}
                          </span>
                          <span v-else class="text-muted small">
                            Sin registro
                          </span>
                        </td>
                        <td>
                          <div class="d-flex flex-column gap-1">
                            <span
                              v-if="vehiculo.documentos_vencidos.length > 0"
                              class="badge bg-danger"
                            >
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              Vencidos ({{
                                vehiculo.documentos_vencidos.length
                              }})
                            </span>
                            <span
                              v-if="vehiculo.paquetes.length <= 0"
                              class="badge bg-danger"
                            >
                              <i class="fas fa-times me-1"></i>
                              Sin paquete
                            </span>
                            <span
                              v-if="vehiculo.documentos_pendientes.length > 0"
                              class="badge bg-warning"
                            >
                              <i class="fas fa-clock me-1"></i>
                              Pendientes ({{
                                vehiculo.documentos_pendientes.length
                              }})
                            </span>
                            <span
                              v-if="
                                vehiculo.documentos_no_verificados.length > 0
                              "
                              class="badge bg-info"
                            >
                              <i class="fas fa-question me-1"></i>
                              No verificados ({{
                                vehiculo.documentos_no_verificados.length
                              }})
                            </span>
                            <span
                              v-if="
                                vehiculo.documentos_vencidos.length === 0 &&
                                vehiculo.documentos_pendientes.length === 0 &&
                                vehiculo.documentos_no_verificados.length ===
                                  0 &&
                                vehiculo.paquetes.length > 0
                              "
                              class="badge bg-success"
                            >
                              <i class="fas fa-check me-1"></i>
                              Verificado
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            data-toggle="modal"
                            data-target="#modal-form-estado"
                            style="cursor: pointer"
                            v-bind:class="[
                              vehiculo.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                            @click="llenarModal(vehiculo.id, vehiculo.estado)"
                          >
                            {{ vehiculo.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'argentina.camiones.editarTransportadora'
                                ) && !admin
                              "
                              @click="edit(vehiculo, 3)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-info"
                              v-else-if="
                                $store.getters.can('argentina.camiones.show')
                              "
                              @click="edit(vehiculo, 1)"
                              title="Ver detalles"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                empresa.length > 0 &&
                                vehiculo.tipo_propiedad == 1 &&
                                vehiculo.empresa_id &&
                                empresa[0].id == vehiculo.empresa_id &&
                                $store.getters.can('argentina.camiones.edit')
                              "
                              @click="edit(vehiculo, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-else-if="
                                (empresa.length === 0 ||
                                  vehiculo.tipo_propiedad != 1) &&
                                $store.getters.can('argentina.camiones.edit')
                              "
                              @click="edit(vehiculo, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              v-if="
                                $store.getters.can('argentina.camiones.show')
                              "
                              @click="
                                llenarModalHistorial(
                                  'App\\Vehiculo',
                                  vehiculo.id
                                )
                              "
                              title="Ver historial"
                            >
                              <i class="fas fa-history"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can('argentina.camiones.asignarPatentes')
                              "
                              data-toggle="modal"
                              data-target="#modal-vehiculo-patente"
                              data-bs-toggle="tooltip"
                              title="Asignar Patentes"
                              @click="
                                $refs.vehiculoPatente.abrir(
                                  vehiculo.patentes_cliente,
                                  vehiculo.id,
                                  vehiculo.placa
                                )
                              "
                            >
                              <i class="fas fa-id-card"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!vehiculos.data || vehiculos.data.length === 0"
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay camiones para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Camiones..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="vehiculos.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        vehiculos.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        vehiculos.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        vehiculos.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="vehiculos"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right m-0"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <VehiculoEstado ref="VehiculoEstado" />
        <HistorialEstado ref="HistorialEstado" />
        <VehiculoPatente ref="vehiculoPatente" />
      </div>
    </div>
    <VehiculoExport ref="VehiculoExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import VehiculoEstado from "./VehiculoEstado";
import HistorialEstado from "../../../admin/basico/historialEstado/HistorialEstado";
import VehiculoExport from "./VehiculoExport";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
import VehiculoPatente from "./VehiculoPatente";

export default {
  name: "CamionesIndex",
  components: {
    pagination,
    VehiculoEstado,
    VehiculoExport,
    HistorialEstado,
    vSelect,
    Loading,
    VehiculoPatente,
  },
  data() {
    return {
      linea_negocio: [],
      empresas: [],
      empresa: this.$store.getters.getUser.empresas,
      tipo_vehiculo: [],
      user: null,
      admin: null,
      cargando: false,
      filtros: {
        placa: null,
        empresa: null,
        empresa_id: null,
        estado: null,
        modelo: null,
        marca: null,
        marca_id: null,
        combustible: null,
        combustible_id: null,
        tipo_vehiculo_id: null,
        tiene_satelital: null,
      },
      vehiculos: {},
      listasForms: {
        empresas: [],
        tiposCarrocerias: [],
        estados: [],
        lineas_negocio: [],
        selct_empresa: [],
        marcas: [],
        combustibles: [],
        tipos_vehiculos: [],
      },
      combustible: null,
      marca: null,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  validations: {},
  methods: {
    formatearFechaHora(fecha) {
      if (!fecha) return "";
      const d = new Date(fecha);
      if (isNaN(d.getTime())) return fecha;
      return d.toLocaleString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    getIndex(page = 1) {
      this.cargando = true;
      this.filtros.empresa_id = null;
      this.filtros.marca_id = null;
      this.filtros.combustible_id = null;
      if (this.listasForms.selct_empresa) {
        this.filtros.empresa_id = this.listasForms.selct_empresa.id;
      }
      if (this.marca) {
        this.filtros.marca_id = this.marca.numeracion;
      }
      if (this.combustible) {
        this.filtros.combustible_id = this.combustible.numeracion;
      }
      if (this.tipo_vehiculo) {
        this.filtros.tipo_vehiculo_id = this.tipo_vehiculo.id;
      }
      axios
        .get("/api/argentina/camiones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.vehiculos = response.data;
          this.cargando = false;
        });

      if (this.$store.state.user) {
        const administrador = this.$store.state.user.roles.find(
          (administrador) => administrador.id === 1
        );
        if (administrador) {
          this.admin = administrador.id;
        }
      }
    },

    getLineasNegocio() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineas_negocio = response.data;
      });
    },

    getEmpresas() {
      // OBLIGATORIO: Cargar solo empresas con pais_id = 3
      axios
        .get("/api/argentina/empresas/lista", {
          params: {
            pais_id: 3,
          },
        })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },

    getTiposCarrocerias() {
      axios.get("/api/lista/9").then((response) => {
        this.listasForms.tiposCarrocerias = response.data;
      });
    },

    getMarcas() {
      axios.get("/api/lista/12").then((response) => {
        this.listasForms.marcas = response.data;
      });
    },

    getTiposCombustible() {
      axios.get("/api/lista/24").then((response) => {
        this.listasForms.combustibles = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    async getTiposVehiculos() {
      // OBLIGATORIO: Filtrar solo tipos de vehículos con linea_negocio_id = 15
      await axios
        .get("/api/admin/tiposVehiculos/lista", {
          params: {
            linea_negocio_id: [15],
          },
        })
        .then((response) => {
          this.listasForms.tipos_vehiculos = response.data;
        });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        // OBLIGATORIO: Buscar solo empresas con pais_id = 3
        var url = "api/argentina/empresas/lista?razon=" + search + "&pais_id=3";
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(idVehiculo) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/argentina/camiones/" + idVehiculo)
            .then((response) => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino el vehículo exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Flota/CamionesForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(vehiculo, opcion) {
      return this.$router.push({
        name: "/Argentina/Flota/CamionesForm",
        params: {
          accion: "Editar",
          data_edit: vehiculo,
          id: vehiculo.id,
          opcion: opcion,
        },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Argentina/Flota/CamionesPivotTable",
      });
    },
    llenarModal(id, estado) {
      if (this.$store.getters.can("argentina.camiones.editStatus")) {
        this.$refs.VehiculoEstado.llenar_modal(id, estado);
      }
    },

    async llenarModalHistorial(entidad, entidad_id) {
      if (this.$store.getters.can("argentina.camiones.show")) {
        // Asegurarse de que la referencia existe
        if (this.$refs.HistorialEstado) {
          await this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
          // Abrir el modal después de cargar los datos
          this.$nextTick(() => {
            const jQuery = window.jQuery || window.$;
            if (jQuery) {
              jQuery("#modal-historial-estado").modal("show");
            }
          });
        } else {
          console.error("HistorialEstado ref no encontrada");
        }
      }
    },
    generarListadoExcel() {
      this.$parent.cargando = true;

      axios({
        method: "POST",
        url: "/api/argentina/camiones/export",
        data: this.form,
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    limpiarFiltros() {
      this.filtros = {
        placa: null,
        empresa: null,
        empresa_id: null,
        estado: null,
        modelo: null,
        marca: null,
        marca_id: null,
        combustible: null,
        combustible_id: null,
        tipo_vehiculo_id: null,
        tiene_satelital: null,
      };
      this.listasForms.selct_empresa = null;
      this.marca = null;
      this.combustible = null;
      this.tipo_vehiculo = null;
      this.vehiculos = {};
      this.getIndex();
    },
  },
  mounted() {
    this.getIndex();
    this.getEmpresas();
    this.getTiposCarrocerias();
    this.getEstados();
    this.getLineasNegocio();
    this.getMarcas();
    this.getTiposCombustible();
    this.getTiposVehiculos();
  },
};
</script>
